// extracted by mini-css-extract-plugin
export var cartContainer = "_ja-4";
export var gray = "_ja-1";
export var itemContainer = "_ja-2";
export var itemDetails = "_ja-3";
export var strong = "_ja-0";